export const mockItems = [
  {
    id: "1",
    name: "Nasi Goreng",
    sku: "NG001",
    barcode: "1234567890123",
    cost_price: 15000,
    selling_price: 25000,
    min_stock_level: 10,
    max_stock_level: 50,
    is_active: true,
    is_recipe_based: true,
    category: "Foods",
    category_group: "Main Course",
    recipe_id: "1",
  },
  {
    id: "2",
    name: "Mie Goreng",
    sku: "MG001",
    barcode: "1234567890124",
    cost_price: 12000,
    selling_price: 22000,
    min_stock_level: 8,
    max_stock_level: 40,
    is_active: true,
    is_recipe_based: true,
    category: "Foods",
    category_group: "Main Course",
    recipe_id: "2",
  },
  {
    id: "3",
    name: "Es Teh Manis",
    sku: "ETM001",
    barcode: "1234567890125",
    cost_price: 2000,
    selling_price: 5000,
    min_stock_level: 20,
    max_stock_level: 100,
    is_active: true,
    is_recipe_based: false,
    category: "Beverages",
    category_group: "Drinks",
  },
  {
    id: "4",
    name: "Es Jeruk",
    sku: "EJ001",
    barcode: "1234567890126",
    cost_price: 3000,
    selling_price: 8000,
    min_stock_level: 15,
    max_stock_level: 80,
    is_active: true,
    is_recipe_based: false,
    category: "Beverages",
    category_group: "Drinks",
  },
  {
    id: "5",
    name: "Beras",
    sku: "BR001",
    barcode: "1234567890127",
    cost_price: 12000,
    selling_price: 15000,
    min_stock_level: 5,
    max_stock_level: 25,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "6",
    name: "Minyak Goreng",
    sku: "MG002",
    barcode: "1234567890128",
    cost_price: 15000,
    selling_price: 18000,
    min_stock_level: 3,
    max_stock_level: 15,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "7",
    name: "Telur",
    sku: "TL001",
    barcode: "1234567890129",
    cost_price: 2500,
    selling_price: 3500,
    min_stock_level: 30,
    max_stock_level: 150,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "8",
    name: "Ayam",
    sku: "AY001",
    barcode: "1234567890130",
    cost_price: 35000,
    selling_price: 45000,
    min_stock_level: 2,
    max_stock_level: 10,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "9",
    name: "Bawang Merah",
    sku: "BM001",
    barcode: "1234567890131",
    cost_price: 8000,
    selling_price: 12000,
    min_stock_level: 5,
    max_stock_level: 20,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "10",
    name: "Bawang Putih",
    sku: "BP001",
    barcode: "1234567890132",
    cost_price: 6000,
    selling_price: 10000,
    min_stock_level: 3,
    max_stock_level: 15,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "11",
    name: "Wortel",
    sku: "WR001",
    barcode: "1234567890133",
    cost_price: 5000,
    selling_price: 8000,
    min_stock_level: 10,
    max_stock_level: 30,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "12",
    name: "Kacang Polong",
    sku: "KP001",
    barcode: "1234567890134",
    cost_price: 4000,
    selling_price: 7000,
    min_stock_level: 8,
    max_stock_level: 25,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "13",
    name: "Garam",
    sku: "GR001",
    barcode: "1234567890135",
    cost_price: 2000,
    selling_price: 4000,
    min_stock_level: 20,
    max_stock_level: 50,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "14",
    name: "Merica",
    sku: "MR001",
    barcode: "1234567890136",
    cost_price: 3000,
    selling_price: 6000,
    min_stock_level: 15,
    max_stock_level: 40,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "15",
    name: "Kecap Manis",
    sku: "KM001",
    barcode: "1234567890137",
    cost_price: 15000,
    selling_price: 25000,
    min_stock_level: 5,
    max_stock_level: 20,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "16",
    name: "Saus Tiram",
    sku: "ST001",
    barcode: "1234567890138",
    cost_price: 12000,
    selling_price: 20000,
    min_stock_level: 3,
    max_stock_level: 15,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "17",
    name: "Mie Telur",
    sku: "MT001",
    barcode: "1234567890139",
    cost_price: 8000,
    selling_price: 15000,
    min_stock_level: 20,
    max_stock_level: 60,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
  {
    id: "18",
    name: "Kecambah",
    sku: "KC001",
    barcode: "1234567890140",
    cost_price: 3000,
    selling_price: 6000,
    min_stock_level: 15,
    max_stock_level: 40,
    is_active: true,
    is_recipe_based: false,
    category: "Ingredients",
    category_group: "Raw Materials",
  },
];

export const mockRecipes = [
  {
    id: "1",
    name: "Nasi Goreng Spesial",
    description: "Nasi goreng dengan telur, ayam, dan sayuran",
    prep_time: 15,
    cook_time: 10,
    servings: 1,
    instructions:
      "1. Panaskan minyak\n2. Goreng telur\n3. Masukkan nasi\n4. Tambahkan bumbu\n5. Sajikan",
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "2",
    name: "Mie Goreng Ayam",
    description: "Mie goreng dengan ayam dan sayuran",
    prep_time: 10,
    cook_time: 8,
    servings: 1,
    instructions:
      "1. Rebus mie\n2. Goreng ayam\n3. Campur dengan mie\n4. Tambahkan bumbu",
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
];

export const mockRecipeItems = [
  {
    id: "1",
    recipe_id: "1",
    item_id: "5",
    quantity: 0.2,
    unit: "kg",
    notes: "Beras yang sudah dimasak",
    item: mockItems[4], // Beras
  },
  {
    id: "2",
    recipe_id: "1",
    item_id: "6",
    quantity: 0.05,
    unit: "liter",
    notes: "Untuk menggoreng",
    item: mockItems[5], // Minyak Goreng
  },
  {
    id: "3",
    recipe_id: "1",
    item_id: "7",
    quantity: 1,
    unit: "pcs",
    notes: "Telur ayam",
    item: mockItems[6], // Telur
  },
  {
    id: "4",
    recipe_id: "1",
    item_id: "8",
    quantity: 0.1,
    unit: "kg",
    notes: "Ayam potong",
    item: mockItems[7], // Ayam
  },
  {
    id: "5",
    recipe_id: "2",
    item_id: "6",
    quantity: 0.03,
    unit: "liter",
    notes: "Untuk menggoreng",
    item: mockItems[5], // Minyak Goreng
  },
  {
    id: "6",
    recipe_id: "2",
    item_id: "8",
    quantity: 0.15,
    unit: "kg",
    notes: "Ayam potong",
    item: mockItems[7], // Ayam
  },
  // Additional ingredients for Nasi Goreng Spesial
  {
    id: "7",
    recipe_id: "1",
    item_id: "9",
    quantity: 0.05,
    unit: "kg",
    notes: "Bawang merah",
    item: mockItems[8], // Bawang Merah
  },
  {
    id: "8",
    recipe_id: "1",
    item_id: "10",
    quantity: 0.03,
    unit: "kg",
    notes: "Bawang putih",
    item: mockItems[9], // Bawang Putih
  },
  {
    id: "9",
    recipe_id: "1",
    item_id: "11",
    quantity: 0.05,
    unit: "kg",
    notes: "Wortel",
    item: mockItems[10], // Wortel
  },
  {
    id: "10",
    recipe_id: "1",
    item_id: "12",
    quantity: 0.05,
    unit: "kg",
    notes: "Kacang polong",
    item: mockItems[11], // Kacang Polong
  },
  {
    id: "11",
    recipe_id: "1",
    item_id: "13",
    quantity: 0.01,
    unit: "kg",
    notes: "Garam",
    item: mockItems[12], // Garam
  },
  {
    id: "12",
    recipe_id: "1",
    item_id: "14",
    quantity: 0.01,
    unit: "kg",
    notes: "Merica",
    item: mockItems[13], // Merica
  },
  {
    id: "13",
    recipe_id: "1",
    item_id: "15",
    quantity: 0.02,
    unit: "kg",
    notes: "Kecap manis",
    item: mockItems[14], // Kecap Manis
  },
  {
    id: "14",
    recipe_id: "1",
    item_id: "16",
    quantity: 0.01,
    unit: "kg",
    notes: "Saus tiram",
    item: mockItems[15], // Saus Tiram
  },
  // Additional ingredients for Mie Goreng Ayam
  {
    id: "15",
    recipe_id: "2",
    item_id: "17",
    quantity: 0.15,
    unit: "kg",
    notes: "Mie telur",
    item: mockItems[16], // Mie Telur
  },
  {
    id: "16",
    recipe_id: "2",
    item_id: "9",
    quantity: 0.03,
    unit: "kg",
    notes: "Bawang merah",
    item: mockItems[8], // Bawang Merah
  },
  {
    id: "17",
    recipe_id: "2",
    item_id: "10",
    quantity: 0.02,
    unit: "kg",
    notes: "Bawang putih",
    item: mockItems[9], // Bawang Putih
  },
  {
    id: "18",
    recipe_id: "2",
    item_id: "11",
    quantity: 0.03,
    unit: "kg",
    notes: "Wortel",
    item: mockItems[10], // Wortel
  },
  {
    id: "19",
    recipe_id: "2",
    item_id: "12",
    quantity: 0.03,
    unit: "kg",
    notes: "Kacang polong",
    item: mockItems[11], // Kacang Polong
  },
  {
    id: "20",
    recipe_id: "2",
    item_id: "13",
    quantity: 0.01,
    unit: "kg",
    notes: "Garam",
    item: mockItems[12], // Garam
  },
  {
    id: "21",
    recipe_id: "2",
    item_id: "14",
    quantity: 0.01,
    unit: "kg",
    notes: "Merica",
    item: mockItems[13], // Merica
  },
  {
    id: "22",
    recipe_id: "2",
    item_id: "15",
    quantity: 0.02,
    unit: "kg",
    notes: "Kecap manis",
    item: mockItems[14], // Kecap Manis
  },
  {
    id: "23",
    recipe_id: "2",
    item_id: "16",
    quantity: 0.01,
    unit: "kg",
    notes: "Saus tiram",
    item: mockItems[15], // Saus Tiram
  },
  {
    id: "24",
    recipe_id: "2",
    item_id: "18",
    quantity: 0.02,
    unit: "kg",
    notes: "Kecambah",
    item: mockItems[17], // Kecambah
  },
];

export const mockSales = [
  {
    id: "1",
    invoice_no: "INV-2024-001",
    sale_date: "2024-01-15T12:30:00Z",
    payment_type: "cash",
    order_type: "eat_in",
    subtotal: 50000,
    discount: 0,
    tax: 5500,
    total_amount: 55500,
    created_at: "2024-01-15T12:30:00Z",
    items: [
      {
        id: "1",
        sale_id: "1",
        item_id: "1",
        quantity: 2,
        unit_price: 25000,
        total_amount: 50000,
        item_discount: 0,
        notes: "Pedas level 2",
        created_at: "2024-01-15T12:30:00Z",
        item: mockItems[0],
      },
    ],
  },
  {
    id: "2",
    invoice_no: "INV-2024-002",
    sale_date: "2024-01-15T13:15:00Z",
    payment_type: "qris",
    order_type: "take_away",
    subtotal: 30000,
    discount: 2000,
    tax: 3300,
    total_amount: 31300,
    created_at: "2024-01-15T13:15:00Z",
    items: [
      {
        id: "2",
        sale_id: "2",
        item_id: "2",
        quantity: 1,
        unit_price: 22000,
        total_amount: 22000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-15T13:15:00Z",
        item: mockItems[1],
      },
      {
        id: "3",
        sale_id: "2",
        item_id: "3",
        quantity: 1,
        unit_price: 5000,
        total_amount: 5000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-15T13:15:00Z",
        item: mockItems[2],
      },
    ],
  },
  {
    id: "3",
    invoice_no: "INV-2024-003",
    sale_date: "2024-01-15T14:00:00Z",
    payment_type: "credit_card",
    order_type: "eat_in",
    subtotal: 75000,
    discount: 5000,
    tax: 8250,
    total_amount: 78250,
    created_at: "2024-01-15T14:00:00Z",
    items: [
      {
        id: "4",
        sale_id: "3",
        item_id: "1",
        quantity: 2,
        unit_price: 25000,
        total_amount: 50000,
        item_discount: 0,
        notes: "Tidak pedas",
        created_at: "2024-01-15T14:00:00Z",
        item: mockItems[0],
      },
      {
        id: "5",
        sale_id: "3",
        item_id: "4",
        quantity: 2,
        unit_price: 8000,
        total_amount: 16000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-15T14:00:00Z",
        item: mockItems[3],
      },
    ],
  },
  {
    id: "4",
    invoice_no: "INV-2024-004",
    sale_date: "2024-01-16T11:45:00Z",
    payment_type: "split",
    order_type: "eat_in",
    subtotal: 120000,
    discount: 10000,
    tax: 13200,
    total_amount: 123200,
    created_at: "2024-01-16T11:45:00Z",
    items: [
      {
        id: "6",
        sale_id: "4",
        item_id: "1",
        quantity: 3,
        unit_price: 25000,
        total_amount: 75000,
        item_discount: 0,
        notes: "Pedas level 1",
        created_at: "2024-01-16T11:45:00Z",
        item: mockItems[0],
      },
      {
        id: "7",
        sale_id: "4",
        item_id: "2",
        quantity: 2,
        unit_price: 22000,
        total_amount: 44000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T11:45:00Z",
        item: mockItems[1],
      },
      {
        id: "8",
        sale_id: "4",
        item_id: "3",
        quantity: 2,
        unit_price: 5000,
        total_amount: 10000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T11:45:00Z",
        item: mockItems[2],
      },
    ],
  },
  {
    id: "5",
    invoice_no: "INV-2024-005",
    sale_date: "2024-01-16T13:20:00Z",
    payment_type: "cash",
    order_type: "take_away",
    subtotal: 45000,
    discount: 0,
    tax: 4950,
    total_amount: 49950,
    created_at: "2024-01-16T13:20:00Z",
    items: [
      {
        id: "9",
        sale_id: "5",
        item_id: "1",
        quantity: 1,
        unit_price: 25000,
        total_amount: 25000,
        item_discount: 0,
        notes: "Tidak pedas",
        created_at: "2024-01-16T13:20:00Z",
        item: mockItems[0],
      },
      {
        id: "10",
        sale_id: "5",
        item_id: "4",
        quantity: 2,
        unit_price: 8000,
        total_amount: 16000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T13:20:00Z",
        item: mockItems[3],
      },
      {
        id: "11",
        sale_id: "5",
        item_id: "3",
        quantity: 1,
        unit_price: 5000,
        total_amount: 5000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T13:20:00Z",
        item: mockItems[2],
      },
    ],
  },
  {
    id: "6",
    invoice_no: "INV-2024-006",
    sale_date: "2024-01-16T15:10:00Z",
    payment_type: "qris",
    order_type: "eat_in",
    subtotal: 88000,
    discount: 5000,
    tax: 9680,
    total_amount: 92680,
    created_at: "2024-01-16T15:10:00Z",
    items: [
      {
        id: "12",
        sale_id: "6",
        item_id: "2",
        quantity: 3,
        unit_price: 22000,
        total_amount: 66000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T15:10:00Z",
        item: mockItems[1],
      },
      {
        id: "13",
        sale_id: "6",
        item_id: "4",
        quantity: 2,
        unit_price: 8000,
        total_amount: 16000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T15:10:00Z",
        item: mockItems[3],
      },
      {
        id: "14",
        sale_id: "6",
        item_id: "3",
        quantity: 1,
        unit_price: 5000,
        total_amount: 5000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-16T15:10:00Z",
        item: mockItems[2],
      },
    ],
  },
  {
    id: "7",
    invoice_no: "INV-2024-007",
    sale_date: "2024-01-17T10:30:00Z",
    payment_type: "credit_card",
    order_type: "take_away",
    subtotal: 35000,
    discount: 0,
    tax: 3850,
    total_amount: 38850,
    created_at: "2024-01-17T10:30:00Z",
    items: [
      {
        id: "15",
        sale_id: "7",
        item_id: "1",
        quantity: 1,
        unit_price: 25000,
        total_amount: 25000,
        item_discount: 0,
        notes: "Pedas level 3",
        created_at: "2024-01-17T10:30:00Z",
        item: mockItems[0],
      },
      {
        id: "16",
        sale_id: "7",
        item_id: "3",
        quantity: 2,
        unit_price: 5000,
        total_amount: 10000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T10:30:00Z",
        item: mockItems[2],
      },
    ],
  },
  {
    id: "8",
    invoice_no: "INV-2024-008",
    sale_date: "2024-01-17T12:15:00Z",
    payment_type: "cash",
    order_type: "eat_in",
    subtotal: 95000,
    discount: 8000,
    tax: 10450,
    total_amount: 101450,
    created_at: "2024-01-17T12:15:00Z",
    items: [
      {
        id: "17",
        sale_id: "8",
        item_id: "1",
        quantity: 2,
        unit_price: 25000,
        total_amount: 50000,
        item_discount: 0,
        notes: "Pedas level 1",
        created_at: "2024-01-17T12:15:00Z",
        item: mockItems[0],
      },
      {
        id: "18",
        sale_id: "8",
        item_id: "2",
        quantity: 2,
        unit_price: 22000,
        total_amount: 44000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T12:15:00Z",
        item: mockItems[1],
      },
      {
        id: "19",
        sale_id: "8",
        item_id: "4",
        quantity: 1,
        unit_price: 8000,
        total_amount: 8000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T12:15:00Z",
        item: mockItems[3],
      },
    ],
  },
  {
    id: "9",
    invoice_no: "INV-2024-009",
    sale_date: "2024-01-17T14:45:00Z",
    payment_type: "qris",
    order_type: "take_away",
    subtotal: 28000,
    discount: 0,
    tax: 3080,
    total_amount: 31080,
    created_at: "2024-01-17T14:45:00Z",
    items: [
      {
        id: "20",
        sale_id: "9",
        item_id: "2",
        quantity: 1,
        unit_price: 22000,
        total_amount: 22000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T14:45:00Z",
        item: mockItems[1],
      },
      {
        id: "21",
        sale_id: "9",
        item_id: "3",
        quantity: 1,
        unit_price: 5000,
        total_amount: 5000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T14:45:00Z",
        item: mockItems[2],
      },
      {
        id: "22",
        sale_id: "9",
        item_id: "4",
        quantity: 1,
        unit_price: 8000,
        total_amount: 8000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T14:45:00Z",
        item: mockItems[3],
      },
    ],
  },
  {
    id: "10",
    invoice_no: "INV-2024-010",
    sale_date: "2024-01-17T16:30:00Z",
    payment_type: "split",
    order_type: "eat_in",
    subtotal: 150000,
    discount: 12000,
    tax: 16500,
    total_amount: 154500,
    created_at: "2024-01-17T16:30:00Z",
    items: [
      {
        id: "23",
        sale_id: "10",
        item_id: "1",
        quantity: 4,
        unit_price: 25000,
        total_amount: 100000,
        item_discount: 0,
        notes: "Pedas level 2",
        created_at: "2024-01-17T16:30:00Z",
        item: mockItems[0],
      },
      {
        id: "24",
        sale_id: "10",
        item_id: "2",
        quantity: 2,
        unit_price: 22000,
        total_amount: 44000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T16:30:00Z",
        item: mockItems[1],
      },
      {
        id: "25",
        sale_id: "10",
        item_id: "4",
        quantity: 1,
        unit_price: 8000,
        total_amount: 8000,
        item_discount: 0,
        notes: "",
        created_at: "2024-01-17T16:30:00Z",
        item: mockItems[3],
      },
    ],
  },
];

export const mockInventoryItems = [
  {
    id: "1",
    item_id: "1",
    quantity: 25,
    unit: "pcs",
    location: "Kitchen",
    expiry_date: "2024-02-15",
    batch_number: "B001",
    cost_price: 15000,
    supplier_id: "1",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[0],
  },
  {
    id: "2",
    item_id: "2",
    quantity: 18,
    unit: "pcs",
    location: "Kitchen",
    expiry_date: "2024-02-10",
    batch_number: "B002",
    cost_price: 12000,
    supplier_id: "1",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[1],
  },
  {
    id: "3",
    item_id: "3",
    quantity: 85,
    unit: "pcs",
    location: "Bar",
    expiry_date: "2024-01-30",
    batch_number: "B003",
    cost_price: 2000,
    supplier_id: "2",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[2],
  },
  {
    id: "4",
    item_id: "4",
    quantity: 45,
    unit: "pcs",
    location: "Bar",
    expiry_date: "2024-01-25",
    batch_number: "B004",
    cost_price: 3000,
    supplier_id: "2",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[3],
  },
  {
    id: "5",
    item_id: "5",
    quantity: 8,
    unit: "kg",
    location: "Storage",
    expiry_date: "2024-06-15",
    batch_number: "B005",
    cost_price: 12000,
    supplier_id: "3",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[4],
  },
  {
    id: "6",
    item_id: "6",
    quantity: 5,
    unit: "liter",
    location: "Storage",
    expiry_date: "2024-05-15",
    batch_number: "B006",
    cost_price: 15000,
    supplier_id: "3",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[5],
  },
  {
    id: "7",
    item_id: "7",
    quantity: 120,
    unit: "pcs",
    location: "Storage",
    expiry_date: "2024-01-30",
    batch_number: "B007",
    cost_price: 2500,
    supplier_id: "4",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[6],
  },
  {
    id: "8",
    item_id: "8",
    quantity: 3,
    unit: "kg",
    location: "Freezer",
    expiry_date: "2024-01-20",
    batch_number: "B008",
    cost_price: 35000,
    supplier_id: "4",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
    item: mockItems[7],
  },
];

export const mockInventoryTransactions = [
  {
    id: "1",
    inventory_item_id: "1",
    transaction_type: "IN",
    quantity: 30,
    reference_id: "PO001",
    notes: "Initial stock",
    user_id: 1,
    created_at: "2024-01-15T10:00:00Z",
    inventory_item: mockInventoryItems[0],
  },
  {
    id: "2",
    inventory_item_id: "1",
    transaction_type: "OUT",
    quantity: 5,
    reference_id: "SALE001",
    notes: "Used for sales",
    user_id: 1,
    created_at: "2024-01-15T12:30:00Z",
    inventory_item: mockInventoryItems[0],
  },
  {
    id: "3",
    inventory_item_id: "2",
    transaction_type: "IN",
    quantity: 25,
    reference_id: "PO002",
    notes: "Restock",
    user_id: 1,
    created_at: "2024-01-15T11:00:00Z",
    inventory_item: mockInventoryItems[1],
  },
  {
    id: "4",
    inventory_item_id: "3",
    transaction_type: "IN",
    quantity: 100,
    reference_id: "PO003",
    notes: "Beverage stock",
    user_id: 1,
    created_at: "2024-01-15T09:00:00Z",
    inventory_item: mockInventoryItems[2],
  },
  {
    id: "5",
    inventory_item_id: "3",
    transaction_type: "OUT",
    quantity: 15,
    reference_id: "SALE002",
    notes: "Sold",
    user_id: 1,
    created_at: "2024-01-15T13:15:00Z",
    inventory_item: mockInventoryItems[2],
  },
];

export const mockAnalyticsData = {
  // Key performance indicators
  totalSales: 500,
  totalRevenue: 25000000,
  averageOrderValue: 50000,
  totalExpenses: 15000000,
  profitMargin: 40,

  // Top selling items with detailed metrics
  topSellingItems: [
    {
      name: "Nasi Goreng",
      quantity: 125,
      revenue: 3125000,
      cost: 1875000,
      profit: 1250000,
      profitMargin: 40,
      category: "Main Course",
      popularity: 85,
    },
    {
      name: "Mie Goreng",
      quantity: 98,
      revenue: 2156000,
      cost: 1293600,
      profit: 862400,
      profitMargin: 40,
      category: "Main Course",
      popularity: 78,
    },
    {
      name: "Es Teh Manis",
      quantity: 156,
      revenue: 780000,
      cost: 312000,
      profit: 468000,
      profitMargin: 60,
      category: "Beverages",
      popularity: 92,
    },
    {
      name: "Sate Ayam",
      quantity: 87,
      revenue: 2436000,
      cost: 1044000,
      profit: 1392000,
      profitMargin: 57,
      category: "Main Course",
      popularity: 88,
    },
    {
      name: "Gado-gado",
      quantity: 65,
      revenue: 1170000,
      cost: 455000,
      profit: 715000,
      profitMargin: 61,
      category: "Appetizer",
      popularity: 72,
    },
  ],

  // Low stock items with detailed information
  lowStockItems: [
    {
      name: "Rice",
      currentStock: 50,
      minStockLevel: 100,
      maxStockLevel: 200,
      category: "Grains",
      unit: "kg",
      daysUntilStockout: 5,
      status: "critical",
    },
    {
      name: "Chicken",
      currentStock: 20,
      minStockLevel: 50,
      maxStockLevel: 100,
      category: "Meat",
      unit: "kg",
      daysUntilStockout: 3,
      status: "critical",
    },
    {
      name: "Vegetables",
      currentStock: 30,
      minStockLevel: 80,
      maxStockLevel: 150,
      category: "Produce",
      unit: "kg",
      daysUntilStockout: 4,
      status: "critical",
    },
    {
      name: "Cooking Oil",
      currentStock: 15,
      minStockLevel: 40,
      maxStockLevel: 80,
      category: "Cooking",
      unit: "liter",
      daysUntilStockout: 2,
      status: "critical",
    },
    {
      name: "Spices",
      currentStock: 25,
      minStockLevel: 40,
      maxStockLevel: 80,
      category: "Seasoning",
      unit: "pack",
      daysUntilStockout: 6,
      status: "warning",
    },
  ],

  // Recipe performance with comprehensive metrics
  recipePerformance: [
    {
      name: "Nasi Goreng",
      popularity: 85,
      profitability: 75,
      cost: 15000,
      revenue: 25000,
      category: "Main Course",
      preparationTime: 15,
      difficulty: "Medium",
      ingredients: 8,
      rating: 4.5,
      orderCount: 125,
      totalRevenue: 3125000,
      totalCost: 1875000,
      profit: 1250000,
    },
    {
      name: "Mie Goreng",
      popularity: 70,
      profitability: 80,
      cost: 18000,
      revenue: 30000,
      category: "Main Course",
      preparationTime: 12,
      difficulty: "Easy",
      ingredients: 6,
      rating: 4.2,
      orderCount: 98,
      totalRevenue: 2156000,
      totalCost: 1293600,
      profit: 862400,
    },
    {
      name: "Sate Ayam",
      popularity: 90,
      profitability: 85,
      cost: 12000,
      revenue: 28000,
      category: "Main Course",
      preparationTime: 20,
      difficulty: "Hard",
      ingredients: 10,
      rating: 4.8,
      orderCount: 87,
      totalRevenue: 2436000,
      totalCost: 1044000,
      profit: 1392000,
    },
    {
      name: "Gado-gado",
      popularity: 60,
      profitability: 70,
      cost: 8000,
      revenue: 18000,
      category: "Appetizer",
      preparationTime: 10,
      difficulty: "Easy",
      ingredients: 5,
      rating: 4.0,
      orderCount: 65,
      totalRevenue: 1170000,
      totalCost: 455000,
      profit: 715000,
    },
    {
      name: "Soto Ayam",
      popularity: 75,
      profitability: 65,
      cost: 14000,
      revenue: 22000,
      category: "Soup",
      preparationTime: 25,
      difficulty: "Medium",
      ingredients: 12,
      rating: 4.3,
      orderCount: 72,
      totalRevenue: 1584000,
      totalCost: 1008000,
      profit: 576000,
    },
    {
      name: "Rendang",
      popularity: 88,
      profitability: 90,
      cost: 20000,
      revenue: 35000,
      category: "Main Course",
      preparationTime: 45,
      difficulty: "Hard",
      ingredients: 15,
      rating: 4.7,
      orderCount: 56,
      totalRevenue: 1960000,
      totalCost: 1120000,
      profit: 840000,
    },
  ],

  // Sales by payment method
  salesByPaymentMethod: {
    cash: 11250000,
    credit_card: 7500000,
    qris: 3750000,
    bank_transfer: 1875000,
    e_wallet: 625000,
  },

  // Sales by order type
  salesByOrderType: {
    dine_in: 16750000,
    takeaway: 6250000,
    delivery: 2000000,
  },

  // Stock movements with detailed tracking
  stockMovements: [
    {
      item: "Rice",
      in: 200,
      out: 150,
      date: "2024-01-15",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 2400000,
    },
    {
      item: "Chicken",
      in: 100,
      out: 80,
      date: "2024-01-15",
      type: "purchase",
      supplier: "Supplier Telur Ayam",
      cost: 2500000,
    },
    {
      item: "Vegetables",
      in: 150,
      out: 120,
      date: "2024-01-15",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 1200000,
    },
    {
      item: "Cooking Oil",
      in: 50,
      out: 35,
      date: "2024-01-14",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 750000,
    },
    {
      item: "Noodles",
      in: 80,
      out: 65,
      date: "2024-01-14",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 400000,
    },
  ],

  // Cost trends with reasons
  costTrends: [
    {
      recipe: "Nasi Goreng",
      previousCost: 14000,
      currentCost: 15000,
      change: 7.1,
      trend: "increasing",
      reason: "Rice price increase",
    },
    {
      recipe: "Mie Goreng",
      previousCost: 17000,
      currentCost: 18000,
      change: 5.9,
      trend: "increasing",
      reason: "Noodle price increase",
    },
    {
      recipe: "Sate Ayam",
      previousCost: 11000,
      currentCost: 12000,
      change: 9.1,
      trend: "increasing",
      reason: "Chicken price increase",
    },
    {
      recipe: "Gado-gado",
      previousCost: 7500,
      currentCost: 8000,
      change: 6.7,
      trend: "increasing",
      reason: "Vegetable price increase",
    },
    {
      recipe: "Soto Ayam",
      previousCost: 13000,
      currentCost: 14000,
      change: 7.7,
      trend: "increasing",
      reason: "Chicken and spice price increase",
    },
    {
      recipe: "Rendang",
      previousCost: 18500,
      currentCost: 20000,
      change: 8.1,
      trend: "increasing",
      reason: "Beef price increase",
    },
  ],

  // Stock levels with comprehensive data
  stockLevels: [
    {
      name: "Rice",
      currentStock: 50,
      minStockLevel: 100,
      maxStockLevel: 200,
      category: "Grains",
      unit: "kg",
      cost: 12000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-10",
      daysUntilStockout: 5,
      status: "critical",
    },
    {
      name: "Chicken",
      currentStock: 20,
      minStockLevel: 50,
      maxStockLevel: 100,
      category: "Meat",
      unit: "kg",
      cost: 25000,
      supplier: "Supplier Telur Ayam",
      lastRestocked: "2024-01-12",
      daysUntilStockout: 3,
      status: "critical",
    },
    {
      name: "Vegetables",
      currentStock: 30,
      minStockLevel: 80,
      maxStockLevel: 150,
      category: "Produce",
      unit: "kg",
      cost: 8000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-13",
      daysUntilStockout: 4,
      status: "critical",
    },
    {
      name: "Cooking Oil",
      currentStock: 15,
      minStockLevel: 40,
      maxStockLevel: 80,
      category: "Cooking",
      unit: "liter",
      cost: 15000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-08",
      daysUntilStockout: 2,
      status: "critical",
    },
    {
      name: "Noodles",
      currentStock: 45,
      minStockLevel: 60,
      maxStockLevel: 120,
      category: "Grains",
      unit: "pack",
      cost: 5000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-14",
      daysUntilStockout: 7,
      status: "warning",
    },
    {
      name: "Beef",
      currentStock: 35,
      minStockLevel: 30,
      maxStockLevel: 80,
      category: "Meat",
      unit: "kg",
      cost: 45000,
      supplier: "Supplier Telur Ayam",
      lastRestocked: "2024-01-15",
      daysUntilStockout: 10,
      status: "good",
    },
    {
      name: "Eggs",
      currentStock: 120,
      minStockLevel: 100,
      maxStockLevel: 200,
      category: "Protein",
      unit: "pieces",
      cost: 2500,
      supplier: "Supplier Telur Ayam",
      lastRestocked: "2024-01-14",
      daysUntilStockout: 15,
      status: "good",
    },
    {
      name: "Spices",
      currentStock: 25,
      minStockLevel: 40,
      maxStockLevel: 80,
      category: "Seasoning",
      unit: "pack",
      cost: 3000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-09",
      daysUntilStockout: 6,
      status: "warning",
    },
    {
      name: "Sugar",
      currentStock: 80,
      minStockLevel: 50,
      maxStockLevel: 100,
      category: "Sweetener",
      unit: "kg",
      cost: 12000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-11",
      daysUntilStockout: 20,
      status: "good",
    },
    {
      name: "Salt",
      currentStock: 60,
      minStockLevel: 30,
      maxStockLevel: 60,
      category: "Seasoning",
      unit: "kg",
      cost: 2000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-10",
      daysUntilStockout: 25,
      status: "good",
    },
  ],

  // Additional analytics data
  salesByTime: [
    { time: "06:00-09:00", sales: 12, revenue: 600000, percentage: 12 },
    { time: "09:00-12:00", sales: 45, revenue: 2250000, percentage: 45 },
    { time: "12:00-15:00", sales: 78, revenue: 3900000, percentage: 78 },
    { time: "15:00-18:00", sales: 34, revenue: 1700000, percentage: 34 },
    { time: "18:00-21:00", sales: 89, revenue: 4450000, percentage: 89 },
    { time: "21:00-24:00", sales: 23, revenue: 1150000, percentage: 23 },
  ],

  salesByDay: [
    { day: "Monday", sales: 45, revenue: 2250000, averageOrder: 50000 },
    { day: "Tuesday", sales: 52, revenue: 2600000, averageOrder: 50000 },
    { day: "Wednesday", sales: 48, revenue: 2400000, averageOrder: 50000 },
    { day: "Thursday", sales: 55, revenue: 2750000, averageOrder: 50000 },
    { day: "Friday", sales: 68, revenue: 3400000, averageOrder: 50000 },
    { day: "Saturday", sales: 75, revenue: 3750000, averageOrder: 50000 },
    { day: "Sunday", sales: 82, revenue: 4100000, averageOrder: 50000 },
  ],

  customerSegments: [
    { segment: "New Customers", count: 45, revenue: 2250000, percentage: 22.5 },
    {
      segment: "Returning Customers",
      count: 156,
      revenue: 7800000,
      percentage: 77.5,
    },
    { segment: "VIP Customers", count: 23, revenue: 1150000, percentage: 11.5 },
  ],

  orderTypes: [
    { type: "Dine-in", count: 134, revenue: 6700000, percentage: 67 },
    { type: "Takeaway", count: 45, revenue: 2250000, percentage: 22.5 },
    { type: "Delivery", count: 21, revenue: 1050000, percentage: 10.5 },
  ],
};

export const mockExpenses = [
  {
    id: "1",
    expense_type_id: "1",
    date: "2024-01-15",
    description_id: "1",
    category_id: "1",
    price: 500000,
    quantity: 1,
    unit_id: "1",
    supplier_id: "1",
    staff_name: undefined,
    user_id: 1,
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "2",
    expense_type_id: "2",
    date: "2024-01-15",
    description_id: "2",
    category_id: "2",
    price: 150000,
    quantity: 1,
    unit_id: "2",
    supplier_id: "2",
    staff_name: undefined,
    user_id: 1,
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
];

export const mockExpenseStats = {
  total_amount: 650000,
  expenses_by_type: {
    "Bahan Baku": 500000,
    Operasional: 150000,
  },
};

// Additional mock data for users
export const mockUsers = [
  {
    id: 1,
    username: "admin",
    email: "admin@bukubali.com",
    role: "ADMIN" as const,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
    settings: {
      preferredModel: "gpt2",
      theme: "light",
      language: "id",
    },
  },
  {
    id: 2,
    username: "worker1",
    email: "worker1@bukubali.com",
    role: "WORKER" as const,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
    settings: {
      preferredModel: "roberta",
      theme: "dark",
      language: "id",
    },
  },
  {
    id: 3,
    username: "worker2",
    email: "worker2@bukubali.com",
    role: "WORKER" as const,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
    settings: {
      preferredModel: "gpt2",
      theme: "light",
      language: "en",
    },
  },
];

// Additional mock data for suppliers
export const mockSuppliers = [
  {
    id: "1",
    name: "Toko Sumber Makmur",
    contact_person: "Pak Budi",
    email: "info@sumbermakmur.com",
    phone: "0361-123456",
    address: "Jl. Raya Kuta No. 123, Kuta, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "PT Gas Indonesia",
    contact_person: "Ibu Sari",
    email: "sales@gasindonesia.co.id",
    phone: "0361-654321",
    address: "Jl. Sunset Road No. 45, Kuta, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "Toko Bahan Dapur",
    contact_person: "Pak Joko",
    email: "order@bahanbali.com",
    phone: "0361-789012",
    address: "Jl. Legian No. 78, Kuta, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "Supplier Telur Ayam",
    contact_person: "Pak Sutejo",
    email: "telur@supplier.com",
    phone: "0361-345678",
    address: "Jl. Uluwatu No. 90, Jimbaran, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

// Additional mock data for expense categories
export const mockExpenseCategories = [
  {
    id: "1",
    name: "Makanan",
    description: "Bahan makanan dan makanan jadi",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "Minuman",
    description: "Bahan minuman dan minuman jadi",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "Peralatan",
    description: "Peralatan dapur dan kantor",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "Kemasan",
    description: "Kemasan produk dan bahan kemasan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "5",
    name: "Utilitas",
    description: "Listrik, air, internet, dan gas",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

// Additional mock data for expense descriptions
export const mockExpenseDescriptions = [
  {
    id: "1",
    name: "Beras",
    description: "Beras premium untuk nasi goreng",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "Gas",
    description: "Gas untuk kompor dapur",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "Plastik",
    description: "Plastik kemasan untuk take away",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "Sapu",
    description: "Sapu lantai untuk kebersihan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "5",
    name: "Minyak Goreng",
    description: "Minyak goreng untuk memasak",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "6",
    name: "Telur",
    description: "Telur ayam untuk masakan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "7",
    name: "Ayam",
    description: "Ayam potong untuk masakan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "8",
    name: "Sayuran",
    description: "Sayuran segar untuk masakan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

// Additional mock data for expense units
export const mockExpenseUnits = [
  {
    id: "1",
    name: "kg",
    symbol: "kg",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "liter",
    symbol: "L",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "pcs",
    symbol: "pcs",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "pack",
    symbol: "pack",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "5",
    name: "gram",
    symbol: "g",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "6",
    name: "ml",
    symbol: "ml",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

// Additional mock data for expense types
export const mockExpenseTypes = [
  {
    id: "1",
    name: "Bahan Baku",
    description: "Bahan baku untuk produksi makanan",
    required_fields: [
      "description_id",
      "category_id",
      "price",
      "quantity",
      "unit_id",
    ],
    available_fields: ["supplier_id", "staff_name"],
    is_active: true,
    worker_accessible: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "Operasional",
    description: "Biaya operasional sehari-hari",
    required_fields: ["description_id", "category_id", "price"],
    available_fields: ["supplier_id", "staff_name"],
    is_active: true,
    worker_accessible: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "Gaji",
    description: "Gaji karyawan dan upah",
    required_fields: ["description_id", "price"],
    available_fields: ["staff_name"],
    is_active: true,
    worker_accessible: false,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "Utilitas",
    description: "Listrik, air, internet, dan gas",
    required_fields: ["description_id", "price"],
    available_fields: ["supplier_id"],
    is_active: true,
    worker_accessible: false,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "5",
    name: "Peralatan",
    description: "Peralatan dapur dan kantor",
    required_fields: ["description_id", "category_id", "price"],
    available_fields: ["supplier_id", "staff_name"],
    is_active: true,
    worker_accessible: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

// Mock data for analytics components
export const mockInventoryAnalyticsData = {
  stockLevels: [
    {
      name: "Rice",
      currentStock: 50,
      minStockLevel: 100,
      maxStockLevel: 200,
      category: "Grains",
      unit: "kg",
      cost: 12000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-10",
      daysUntilStockout: 5,
      status: "critical",
    },
    {
      name: "Chicken",
      currentStock: 20,
      minStockLevel: 50,
      maxStockLevel: 100,
      category: "Meat",
      unit: "kg",
      cost: 25000,
      supplier: "Supplier Telur Ayam",
      lastRestocked: "2024-01-12",
      daysUntilStockout: 3,
      status: "critical",
    },
    {
      name: "Vegetables",
      currentStock: 30,
      minStockLevel: 80,
      maxStockLevel: 150,
      category: "Produce",
      unit: "kg",
      cost: 8000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-13",
      daysUntilStockout: 4,
      status: "critical",
    },
    {
      name: "Cooking Oil",
      currentStock: 15,
      minStockLevel: 40,
      maxStockLevel: 80,
      category: "Cooking",
      unit: "liter",
      cost: 15000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-08",
      daysUntilStockout: 2,
      status: "critical",
    },
    {
      name: "Noodles",
      currentStock: 45,
      minStockLevel: 60,
      maxStockLevel: 120,
      category: "Grains",
      unit: "pack",
      cost: 5000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-14",
      daysUntilStockout: 7,
      status: "warning",
    },
    {
      name: "Beef",
      currentStock: 35,
      minStockLevel: 30,
      maxStockLevel: 80,
      category: "Meat",
      unit: "kg",
      cost: 45000,
      supplier: "Supplier Telur Ayam",
      lastRestocked: "2024-01-15",
      daysUntilStockout: 10,
      status: "good",
    },
    {
      name: "Eggs",
      currentStock: 120,
      minStockLevel: 100,
      maxStockLevel: 200,
      category: "Protein",
      unit: "pieces",
      cost: 2500,
      supplier: "Supplier Telur Ayam",
      lastRestocked: "2024-01-14",
      daysUntilStockout: 15,
      status: "good",
    },
    {
      name: "Spices",
      currentStock: 25,
      minStockLevel: 40,
      maxStockLevel: 80,
      category: "Seasoning",
      unit: "pack",
      cost: 3000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-09",
      daysUntilStockout: 6,
      status: "warning",
    },
    {
      name: "Sugar",
      currentStock: 80,
      minStockLevel: 50,
      maxStockLevel: 100,
      category: "Sweetener",
      unit: "kg",
      cost: 12000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-11",
      daysUntilStockout: 20,
      status: "good",
    },
    {
      name: "Salt",
      currentStock: 60,
      minStockLevel: 30,
      maxStockLevel: 60,
      category: "Seasoning",
      unit: "kg",
      cost: 2000,
      supplier: "Toko Bahan Dapur",
      lastRestocked: "2024-01-10",
      daysUntilStockout: 25,
      status: "good",
    },
  ],

  stockMovements: [
    {
      item: "Rice",
      in: 200,
      out: 150,
      date: "2024-01-15",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 2400000,
    },
    {
      item: "Chicken",
      in: 100,
      out: 80,
      date: "2024-01-15",
      type: "purchase",
      supplier: "Supplier Telur Ayam",
      cost: 2500000,
    },
    {
      item: "Vegetables",
      in: 150,
      out: 120,
      date: "2024-01-15",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 1200000,
    },
    {
      item: "Cooking Oil",
      in: 50,
      out: 35,
      date: "2024-01-14",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 750000,
    },
    {
      item: "Noodles",
      in: 80,
      out: 65,
      date: "2024-01-14",
      type: "purchase",
      supplier: "Toko Bahan Dapur",
      cost: 400000,
    },
    {
      item: "Beef",
      in: 60,
      out: 45,
      date: "2024-01-13",
      type: "purchase",
      supplier: "Supplier Telur Ayam",
      cost: 2700000,
    },
  ],

  inventoryCategories: [
    {
      category: "Grains",
      totalItems: 2,
      totalValue: 3600000,
      lowStockItems: 2,
      criticalItems: 1,
    },
    {
      category: "Meat",
      totalItems: 2,
      totalValue: 5200000,
      lowStockItems: 1,
      criticalItems: 1,
    },
    {
      category: "Produce",
      totalItems: 1,
      totalValue: 240000,
      lowStockItems: 1,
      criticalItems: 1,
    },
    {
      category: "Cooking",
      totalItems: 1,
      totalValue: 225000,
      lowStockItems: 1,
      criticalItems: 1,
    },
    {
      category: "Protein",
      totalItems: 1,
      totalValue: 300000,
      lowStockItems: 0,
      criticalItems: 0,
    },
    {
      category: "Seasoning",
      totalItems: 2,
      totalValue: 90000,
      lowStockItems: 1,
      criticalItems: 0,
    },
    {
      category: "Sweetener",
      totalItems: 1,
      totalValue: 960000,
      lowStockItems: 0,
      criticalItems: 0,
    },
  ],

  stockoutPredictions: [
    {
      item: "Cooking Oil",
      predictedDate: "2024-01-17",
      daysLeft: 2,
      urgency: "high",
      recommendedOrder: 50,
    },
    {
      item: "Chicken",
      predictedDate: "2024-01-18",
      daysLeft: 3,
      urgency: "high",
      recommendedOrder: 80,
    },
    {
      item: "Vegetables",
      predictedDate: "2024-01-19",
      daysLeft: 4,
      urgency: "medium",
      recommendedOrder: 100,
    },
    {
      item: "Rice",
      predictedDate: "2024-01-20",
      daysLeft: 5,
      urgency: "medium",
      recommendedOrder: 150,
    },
    {
      item: "Spices",
      predictedDate: "2024-01-21",
      daysLeft: 6,
      urgency: "low",
      recommendedOrder: 40,
    },
  ],

  supplierPerformance: [
    {
      supplier: "Toko Bahan Dapur",
      totalOrders: 8,
      totalValue: 5500000,
      averageDeliveryTime: 2,
      reliability: 95,
      lastOrder: "2024-01-15",
    },
    {
      supplier: "Supplier Telur Ayam",
      totalOrders: 4,
      totalValue: 5200000,
      averageDeliveryTime: 1,
      reliability: 98,
      lastOrder: "2024-01-15",
    },
  ],
};

export const mockSalesAnalyticsData = {
  // Daily sales trend for the last 30 days
  salesTrend: [
    { date: "2024-01-01", sales: 15, revenue: 750000, averageOrder: 50000 },
    { date: "2024-01-02", sales: 18, revenue: 900000, averageOrder: 50000 },
    { date: "2024-01-03", sales: 22, revenue: 1100000, averageOrder: 50000 },
    { date: "2024-01-04", sales: 20, revenue: 1000000, averageOrder: 50000 },
    { date: "2024-01-05", sales: 25, revenue: 1250000, averageOrder: 50000 },
    { date: "2024-01-06", sales: 28, revenue: 1400000, averageOrder: 50000 },
    { date: "2024-01-07", sales: 30, revenue: 1500000, averageOrder: 50000 },
    { date: "2024-01-08", sales: 27, revenue: 1350000, averageOrder: 50000 },
    { date: "2024-01-09", sales: 24, revenue: 1200000, averageOrder: 50000 },
    { date: "2024-01-10", sales: 26, revenue: 1300000, averageOrder: 50000 },
    { date: "2024-01-11", sales: 29, revenue: 1450000, averageOrder: 50000 },
    { date: "2024-01-12", sales: 32, revenue: 1600000, averageOrder: 50000 },
    { date: "2024-01-13", sales: 35, revenue: 1750000, averageOrder: 50000 },
    { date: "2024-01-14", sales: 33, revenue: 1650000, averageOrder: 50000 },
    { date: "2024-01-15", sales: 31, revenue: 1550000, averageOrder: 50000 },
  ],

  // Payment methods breakdown
  paymentMethods: [
    { method: "Cash", count: 45, amount: 2250000, percentage: 45 },
    { method: "Credit Card", count: 30, amount: 1500000, percentage: 30 },
    { method: "QRIS", count: 25, amount: 1250000, percentage: 25 },
    { method: "Bank Transfer", count: 15, amount: 750000, percentage: 15 },
    { method: "E-Wallet", count: 10, amount: 500000, percentage: 10 },
  ],

  // Top selling items with detailed metrics
  topSellingItems: [
    {
      name: "Nasi Goreng",
      quantity: 125,
      revenue: 3125000,
      cost: 1875000,
      profit: 1250000,
      profitMargin: 40,
      category: "Main Course",
      popularity: 85,
    },
    {
      name: "Mie Goreng",
      quantity: 98,
      revenue: 2156000,
      cost: 1293600,
      profit: 862400,
      profitMargin: 40,
      category: "Main Course",
      popularity: 78,
    },
    {
      name: "Es Teh Manis",
      quantity: 156,
      revenue: 780000,
      cost: 312000,
      profit: 468000,
      profitMargin: 60,
      category: "Beverages",
      popularity: 92,
    },
    {
      name: "Sate Ayam",
      quantity: 87,
      revenue: 2436000,
      cost: 1044000,
      profit: 1392000,
      profitMargin: 57,
      category: "Main Course",
      popularity: 88,
    },
    {
      name: "Gado-gado",
      quantity: 65,
      revenue: 1170000,
      cost: 455000,
      profit: 715000,
      profitMargin: 61,
      category: "Appetizer",
      popularity: 72,
    },
    {
      name: "Es Jeruk",
      quantity: 89,
      revenue: 712000,
      cost: 267000,
      profit: 445000,
      profitMargin: 62,
      category: "Beverages",
      popularity: 81,
    },
  ],

  // Sales by time of day
  salesByTime: [
    { time: "06:00-09:00", sales: 12, revenue: 600000, percentage: 12 },
    { time: "09:00-12:00", sales: 45, revenue: 2250000, percentage: 45 },
    { time: "12:00-15:00", sales: 78, revenue: 3900000, percentage: 78 },
    { time: "15:00-18:00", sales: 34, revenue: 1700000, percentage: 34 },
    { time: "18:00-21:00", sales: 89, revenue: 4450000, percentage: 89 },
    { time: "21:00-24:00", sales: 23, revenue: 1150000, percentage: 23 },
  ],

  // Sales by day of week
  salesByDay: [
    { day: "Monday", sales: 45, revenue: 2250000, averageOrder: 50000 },
    { day: "Tuesday", sales: 52, revenue: 2600000, averageOrder: 50000 },
    { day: "Wednesday", sales: 48, revenue: 2400000, averageOrder: 50000 },
    { day: "Thursday", sales: 55, revenue: 2750000, averageOrder: 50000 },
    { day: "Friday", sales: 68, revenue: 3400000, averageOrder: 50000 },
    { day: "Saturday", sales: 75, revenue: 3750000, averageOrder: 50000 },
    { day: "Sunday", sales: 82, revenue: 4100000, averageOrder: 50000 },
  ],

  // Customer segments
  customerSegments: [
    { segment: "New Customers", count: 45, revenue: 2250000, percentage: 22.5 },
    {
      segment: "Returning Customers",
      count: 156,
      revenue: 7800000,
      percentage: 77.5,
    },
    { segment: "VIP Customers", count: 23, revenue: 1150000, percentage: 11.5 },
  ],

  // Order types
  orderTypes: [
    { type: "Dine-in", count: 134, revenue: 6700000, percentage: 67 },
    { type: "Takeaway", count: 45, revenue: 2250000, percentage: 22.5 },
    { type: "Delivery", count: 21, revenue: 1050000, percentage: 10.5 },
  ],
};

export const mockRecipeAnalyticsData = {
  recipePerformance: [
    {
      name: "Nasi Goreng",
      popularity: 85,
      profitability: 75,
      cost: 15000,
      revenue: 25000,
      category: "Main Course",
      preparationTime: 15,
      difficulty: "Medium",
      ingredients: 8,
      rating: 4.5,
      orderCount: 125,
      totalRevenue: 3125000,
      totalCost: 1875000,
      profit: 1250000,
    },
    {
      name: "Mie Goreng",
      popularity: 70,
      profitability: 80,
      cost: 18000,
      revenue: 30000,
      category: "Main Course",
      preparationTime: 12,
      difficulty: "Easy",
      ingredients: 6,
      rating: 4.2,
      orderCount: 98,
      totalRevenue: 2156000,
      totalCost: 1293600,
      profit: 862400,
    },
    {
      name: "Sate Ayam",
      popularity: 90,
      profitability: 85,
      cost: 12000,
      revenue: 28000,
      category: "Main Course",
      preparationTime: 20,
      difficulty: "Hard",
      ingredients: 10,
      rating: 4.8,
      orderCount: 87,
      totalRevenue: 2436000,
      totalCost: 1044000,
      profit: 1392000,
    },
    {
      name: "Gado-gado",
      popularity: 60,
      profitability: 70,
      cost: 8000,
      revenue: 18000,
      category: "Appetizer",
      preparationTime: 10,
      difficulty: "Easy",
      ingredients: 5,
      rating: 4.0,
      orderCount: 65,
      totalRevenue: 1170000,
      totalCost: 455000,
      profit: 715000,
    },
    {
      name: "Soto Ayam",
      popularity: 75,
      profitability: 65,
      cost: 14000,
      revenue: 22000,
      category: "Soup",
      preparationTime: 25,
      difficulty: "Medium",
      ingredients: 12,
      rating: 4.3,
      orderCount: 72,
      totalRevenue: 1584000,
      totalCost: 1008000,
      profit: 576000,
    },
    {
      name: "Rendang",
      popularity: 88,
      profitability: 90,
      cost: 20000,
      revenue: 35000,
      category: "Main Course",
      preparationTime: 45,
      difficulty: "Hard",
      ingredients: 15,
      rating: 4.7,
      orderCount: 56,
      totalRevenue: 1960000,
      totalCost: 1120000,
      profit: 840000,
    },
  ],
  costTrends: [
    {
      recipe: "Nasi Goreng",
      previousCost: 14000,
      currentCost: 15000,
      change: 7.1,
      trend: "increasing",
      reason: "Rice price increase",
    },
    {
      recipe: "Mie Goreng",
      previousCost: 17000,
      currentCost: 18000,
      change: 5.9,
      trend: "increasing",
      reason: "Noodle price increase",
    },
    {
      recipe: "Sate Ayam",
      previousCost: 11000,
      currentCost: 12000,
      change: 9.1,
      trend: "increasing",
      reason: "Chicken price increase",
    },
    {
      recipe: "Gado-gado",
      previousCost: 7500,
      currentCost: 8000,
      change: 6.7,
      trend: "increasing",
      reason: "Vegetable price increase",
    },
    {
      recipe: "Soto Ayam",
      previousCost: 13000,
      currentCost: 14000,
      change: 7.7,
      trend: "increasing",
      reason: "Chicken and spice price increase",
    },
    {
      recipe: "Rendang",
      previousCost: 18500,
      currentCost: 20000,
      change: 8.1,
      trend: "increasing",
      reason: "Beef price increase",
    },
  ],
  recipeCategories: [
    {
      category: "Main Course",
      count: 4,
      totalRevenue: 9280000,
      totalCost: 5322600,
      totalProfit: 3957400,
      averagePopularity: 83.25,
      averageProfitability: 82.5,
    },
    {
      category: "Appetizer",
      count: 1,
      totalRevenue: 1170000,
      totalCost: 455000,
      totalProfit: 715000,
      averagePopularity: 60,
      averageProfitability: 70,
    },
    {
      category: "Soup",
      count: 1,
      totalRevenue: 1584000,
      totalCost: 1008000,
      totalProfit: 576000,
      averagePopularity: 75,
      averageProfitability: 65,
    },
  ],
  preparationEfficiency: [
    {
      recipe: "Nasi Goreng",
      preparationTime: 15,
      orderCount: 125,
      efficiency: 8.33,
      rating: 4.5,
    },
    {
      recipe: "Mie Goreng",
      preparationTime: 12,
      orderCount: 98,
      efficiency: 8.17,
      rating: 4.2,
    },
    {
      recipe: "Sate Ayam",
      preparationTime: 20,
      orderCount: 87,
      efficiency: 4.35,
      rating: 4.8,
    },
    {
      recipe: "Gado-gado",
      preparationTime: 10,
      orderCount: 65,
      efficiency: 6.5,
      rating: 4.0,
    },
    {
      recipe: "Soto Ayam",
      preparationTime: 25,
      orderCount: 72,
      efficiency: 2.88,
      rating: 4.3,
    },
    {
      recipe: "Rendang",
      preparationTime: 45,
      orderCount: 56,
      efficiency: 1.24,
      rating: 4.7,
    },
  ],
};

// Mock data for analysis API
export const mockAnalysisInsights = {
  sales_insights: [
    {
      type: "trend",
      title: "Sales Growth Trend",
      description: "Sales have increased by 15% compared to last month",
      confidence: 0.85,
      recommendation: "Consider increasing stock for top-selling items",
    },
    {
      type: "opportunity",
      title: "Peak Hours Analysis",
      description: "Sales peak between 12:00-14:00 and 18:00-20:00",
      confidence: 0.92,
      recommendation: "Optimize staffing during peak hours",
    },
  ],
  inventory_insights: [
    {
      type: "alert",
      title: "Low Stock Alert",
      description: "3 items are running low on stock",
      confidence: 0.95,
      recommendation: "Replenish stock for these items immediately",
    },
    {
      type: "optimization",
      title: "Stock Optimization",
      description: "Some items have excess stock that could be reduced",
      confidence: 0.78,
      recommendation: "Review and adjust stock levels",
    },
  ],
  recipe_insights: [
    {
      type: "performance",
      title: "Recipe Performance",
      description: "Nasi Goreng is the most profitable recipe",
      confidence: 0.88,
      recommendation: "Consider promoting this recipe more",
    },
  ],
};

export const mockAnalysisPredictions = {
  sales_forecast: {
    next_week: 180000,
    next_month: 720000,
    trend: "increasing",
    confidence: 0.82,
  },
  inventory_forecast: {
    items_to_reorder: [
      {
        item_id: "8",
        item_name: "Ayam",
        predicted_shortage_date: "2024-01-25",
      },
      {
        item_id: "6",
        item_name: "Minyak Goreng",
        predicted_shortage_date: "2024-01-28",
      },
    ],
    confidence: 0.75,
  },
  demand_forecast: {
    top_items_next_week: [
      {
        item_id: "1",
        item_name: "Nasi Goreng",
        predicted_demand: 45,
        confidence: 0.85,
      },
      {
        item_id: "2",
        item_name: "Mie Goreng",
        predicted_demand: 32,
        confidence: 0.78,
      },
    ],
  },
};

export const mockAnalysisModels = [
  {
    value: "gpt2",
    label: "GPT-2",
    description: "General purpose language model for text analysis",
  },
  {
    value: "roberta",
    label: "RoBERTa",
    description: "Robustly optimized BERT for business insights",
  },
];

export const mockAnalysisResponse = {
  message: `AI analysis for: "sales trends". Based on the current data, I can provide insights about sales trends, inventory optimization, and business performance.`,
  model_used: "gpt2",
};

// Mock data for expenses API (already exists in data.ts, but adding the ones from expenses.ts)
export const mockExpenseTypesAPI = [
  {
    id: "1",
    name: "Bahan Baku",
    description: "Bahan baku untuk produksi",
    required_fields: [
      "description_id",
      "category_id",
      "price",
      "supplier_id",
      "quantity",
      "unit_id",
    ],
    available_fields: ["supplier_id", "staff_name"],
    is_active: true,
    worker_accessible: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "2",
    name: "Operasional",
    description: "Biaya operasional",
    required_fields: ["description_id", "category_id", "price"],
    available_fields: ["supplier_id", "staff_name"],
    is_active: true,
    worker_accessible: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "3",
    name: "Gaji",
    description: "Gaji karyawan",
    required_fields: ["description_id", "price"],
    available_fields: ["staff_name"],
    is_active: true,
    worker_accessible: false,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "4",
    name: "Utilitas",
    description: "Listrik, air, internet",
    required_fields: ["description_id", "price"],
    available_fields: ["supplier_id"],
    is_active: true,
    worker_accessible: false,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
];

export const mockExpenseCategoriesAPI = [
  {
    id: "1",
    name: "Makanan",
    description: "Bahan makanan",
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "2",
    name: "Minuman",
    description: "Bahan minuman",
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "3",
    name: "Peralatan",
    description: "Peralatan dapur",
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    id: "4",
    name: "Kemasan",
    description: "Kemasan produk",
    is_active: true,
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
];

export const mockExpenseDescriptionsAPI = [
  {
    id: "1",
    name: "Beras",
    description: "Beras premium untuk nasi goreng",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "Gas",
    description: "Gas untuk kompor dapur",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "Plastik",
    description: "Plastik kemasan untuk take away",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "Sapu",
    description: "Sapu lantai untuk kebersihan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "5",
    name: "Minyak Goreng",
    description: "Minyak goreng untuk memasak",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "6",
    name: "Telur",
    description: "Telur ayam untuk masakan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "7",
    name: "Ayam",
    description: "Ayam potong untuk masakan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "8",
    name: "Sayuran",
    description: "Sayuran segar untuk masakan",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

export const mockExpenseUnitsAPI = [
  {
    id: "1",
    name: "kg",
    symbol: "kg",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "liter",
    symbol: "L",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "pcs",
    symbol: "pcs",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "pack",
    symbol: "pack",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "5",
    name: "gram",
    symbol: "g",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "6",
    name: "ml",
    symbol: "ml",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

export const mockExpenseSuppliersAPI = [
  {
    id: "1",
    name: "Toko Sumber Makmur",
    contact_person: "Pak Budi",
    email: "info@sumbermakmur.com",
    phone: "0361-123456",
    address: "Jl. Raya Kuta No. 123, Kuta, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "2",
    name: "PT Gas Indonesia",
    contact_person: "Ibu Sari",
    email: "sales@gasindonesia.co.id",
    phone: "0361-654321",
    address: "Jl. Sunset Road No. 45, Kuta, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "3",
    name: "Toko Bahan Dapur",
    contact_person: "Pak Joko",
    email: "order@bahanbali.com",
    phone: "0361-789012",
    address: "Jl. Legian No. 78, Kuta, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
  {
    id: "4",
    name: "Supplier Telur Ayam",
    contact_person: "Pak Sutejo",
    email: "telur@supplier.com",
    phone: "0361-345678",
    address: "Jl. Uluwatu No. 90, Jimbaran, Bali",
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z",
  },
];

// Helper functions for analytics components
export const getInventoryAnalyticsData = (data?: any) => ({
  stockLevels: data?.lowStockItems || mockInventoryAnalyticsData.stockLevels,
  stockMovements: mockInventoryAnalyticsData.stockMovements,
  inventoryCategories: mockInventoryAnalyticsData.inventoryCategories,
  stockoutPredictions: mockInventoryAnalyticsData.stockoutPredictions,
  supplierPerformance: mockInventoryAnalyticsData.supplierPerformance,
});

export const getSalesAnalyticsData = (data?: any) => ({
  salesTrend: mockSalesAnalyticsData.salesTrend,
  paymentMethods: mockSalesAnalyticsData.paymentMethods,
  topSellingItems:
    data?.topSellingItems || mockSalesAnalyticsData.topSellingItems,
  salesByTime: mockSalesAnalyticsData.salesByTime,
  salesByDay: mockSalesAnalyticsData.salesByDay,
  customerSegments: mockSalesAnalyticsData.customerSegments,
  orderTypes: mockSalesAnalyticsData.orderTypes,
});

export const getRecipeAnalyticsData = (data?: any) => {
  const recipePerformance = data?.recipePerformance || [];
  const costTrends = data?.costTrends || [];

  return {
    recipePerformance:
      recipePerformance.length > 0
        ? recipePerformance
        : mockRecipeAnalyticsData.recipePerformance,
    costTrends:
      costTrends.length > 0 ? costTrends : mockRecipeAnalyticsData.costTrends,
    recipeCategories: mockRecipeAnalyticsData.recipeCategories,
    preparationEfficiency: mockRecipeAnalyticsData.preparationEfficiency,
  };
};

// Mock data for dashboard
export const mockDashboardExpenseStats = {
  total_amount: 650000,
  by_type: {
    "Bahan Baku": 500000,
    Operasional: 150000,
  },
};

export const mockDashboardSalesStats = {
  total_amount: 8750000,
  total_items: 156,
  average_transaction: 56089,
  most_sold_item: {
    name: "Nasi Goreng",
    quantity: 45,
    revenue: 2250000,
  },
  least_sold_item: {
    name: "Es Teh Manis",
    quantity: 8,
    revenue: 80000,
  },
  sales_by_payment_method: {
    cash: 55500,
    qris: 31300,
    credit_card: 78250,
  },
  sales_by_order_type: {
    eat_in: 133750,
    take_away: 31300,
  },
};

// Helper function for dashboard data
export const getDashboardData = (dateRange?: [Date, Date] | null) => {
  // In a real app, this would filter data based on date range
  return {
    expenseStats: mockDashboardExpenseStats,
    salesStats: mockDashboardSalesStats,
  };
};

// Centralized options data for forms and filters
export const mockOptions = {
  // Item categories
  itemCategories: [
    { value: "Foods", label: "Foods" },
    { value: "Beverages", label: "Beverages" },
    { value: "Ingredients", label: "Ingredients" },
    { value: "Supplies", label: "Supplies" },
  ],

  // User roles
  userRoles: [
    { value: "ADMIN", label: "Admin" },
    { value: "WORKER", label: "User" },
  ],

  // Time frames for analytics
  timeFrames: [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ],

  // Order types
  orderTypes: [
    { value: "DINE_IN", label: "Dine In" },
    { value: "TAKEAWAY", label: "Takeaway" },
    { value: "DELIVERY", label: "Delivery" },
  ],

  // Payment methods
  paymentMethods: [
    { value: "CASH", label: "Cash" },
    { value: "CARD", label: "Card" },
    { value: "TRANSFER", label: "Transfer" },
    { value: "QRIS", label: "QRIS" },
  ],

  // Payment methods for sales history
  paymentMethodsHistory: [
    { value: "cash", label: "Cash" },
    { value: "credit_card", label: "Credit Card" },
    { value: "split", label: "Split" },
    { value: "qris", label: "QRIS" },
  ],

  // Order types for sales history
  orderTypesHistory: [
    { value: "eat_in", label: "Eat In" },
    { value: "take_away", label: "Take Away" },
  ],

  // Transaction types
  transactionTypes: [
    { value: "IN", label: "Stock In" },
    { value: "OUT", label: "Stock Out" },
    { value: "ADJUSTMENT", label: "Adjustment" },
    { value: "TRANSFER", label: "Transfer" },
    { value: "WASTE", label: "Waste" },
  ],

  // Units for recipes and ingredients
  units: [
    { value: "pcs", label: "Pieces" },
    { value: "kg", label: "Kilograms" },
    { value: "g", label: "Grams" },
    { value: "l", label: "Liters" },
    { value: "ml", label: "Milliliters" },
    { value: "tbsp", label: "Tablespoons" },
    { value: "tsp", label: "Teaspoons" },
    { value: "cup", label: "Cups" },
  ],

  // Stock status options
  stockStatus: [
    { value: "low_stock", label: "Low Stock" },
    { value: "out_of_stock", label: "Out of Stock" },
    { value: "in_stock", label: "In Stock" },
  ],

  // Expense field options
  expenseFields: [
    { value: "date", label: "Date" },
    { value: "description", label: "Description" },
    { value: "price", label: "Price" },
    { value: "quantity", label: "Quantity" },
    { value: "unit", label: "Unit" },
    { value: "supplier", label: "Supplier" },
    { value: "staff_name", label: "Staff Name" },
  ],

  // Split payment options
  splitPaymentOptions: [
    { value: "cash_card", label: "Cash + Card" },
    { value: "cash_qris", label: "Cash + QRIS" },
    { value: "card_qris", label: "Card + QRIS" },
  ],
};
